App.controller('LifeWithPaymentsConfirmationCtrl', ['$scope', '$sce', '$state', '$stateParams', '$q', '$filter', 'lifeInsuranceWithPaymentsService', '$timeout', '$mdDialog', 'Configurator', 'popUpService', function ($scope, $sce, $state, $stateParams, $q, $filter, lifeInsuranceWithPaymentsService, $timeout, $mdDialog, Configurator, popUpService) {

    $scope.stateParams = $stateParams;

    $scope.page = 'life';
    $scope.$emit('page', $scope.page);

    $scope.step = '';
    $scope.$emit('step', $scope.step);

    // $scope.link = 'root.dashboard';
    // $scope.$emit('link', $scope.link);

    if ($scope.stateParams.persons && $scope.stateParams.choose) {
        $scope.person = $scope.stateParams.person;
        $scope.persons = $scope.stateParams.persons;
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.partner = $scope.stateParams.partner;
        $scope.assured = $scope.stateParams.assured;
        $scope.summary = $scope.stateParams.summary;
        $scope.isAssured = $scope.stateParams.isAssured;
        $scope.isPartner = $scope.stateParams.isPartner;
    } else {
        return $state.go('root.life.start');
    }

    lifeInsuranceWithPaymentsService.getAllPackages().then(function (data) {
        $scope.lifePackages = data.data.group;
        assignPackageInfoToPersons($scope.persons, $scope.choose, $scope.lifePackages);
    });

    $scope.specialPackages = [];

    $scope.accept = function () {
        $scope.form.$setSubmitted();
        $scope.next($scope.form);
    };

    $scope.next = function () {
        var vm = this;

        var el = $('.bottominfo .button.right');

        if (el.hasClass('disabled')) {
            return 0;
        } else {
            el.addClass('disabled');
        }

        function enableNext() {
            var element = $('.bottominfo .button.right');
            if (element.hasClass('disabled')) {
                element.removeClass('disabled');
            }
        }

        if (!vm.form.$valid) {
            var allExplicit = true;
            angular.forEach($scope.persons, function (person) {
                angular.forEach(person.agreements.requiredExplicitAgreementsList, function (explicit) {
                    allExplicit = allExplicit && explicit.accepted;
                })
            })
            if (!allExplicit) {
                popUpService.showPopUp({content: 'Aby przystąpić do ubezpieczenia niezbędne jest potwierdzenie dobrego stanu zdrowia. W przypadku braku oznaczenia oświadczenia o dobrym stanie zdrowia, zapisanie wniosku nie jest możliwe.'})
                document.body.scrollTop = document.documentElement.scrollTop = 80;
                enableNext();
                return 0;
            }
            popUpService.showPopUp({content: 'Aby zapisać wniosek, oznacz wszystkie oświadczenia obowiązkowe (oznaczone gwiazdką).'})
            document.body.scrollTop = document.documentElement.scrollTop = 80;
            enableNext();
            return 0;
        }

        var missingOncologyConfirmation = false;
        var missingCardiologyConfirmation = false;
        angular.forEach($scope.persons, function (person) {
            if (person.agreements.hasOncologyPackage && !person.agreements.oncologyPackage) {
                missingOncologyConfirmation = true;
            }
            if (person.agreements.hasCardiologyPackage && !person.agreements.cardiologyPackage) {
                missingCardiologyConfirmation = true;
            }
        })

        var toSave = {
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary,
            assured: $scope.assured,
            partner: $scope.partner,
            person: $scope.person,
            persons: $scope.persons,
            isAssured: $scope.isAssured,
            isPartner: $scope.isPartner
        };

        function saveDeclaration() {
            var userObject = angular.fromJson(window.sessionStorage.getItem('userObject'));

            var data = $filter('preparePersonsData')(toSave, userObject.branch.id);

            lifeInsuranceWithPaymentsService.saveDeclaration(data).then(function (success) {
                toSave = {
                    choose: null,
                    prices: null,
                    summary: $scope.summary,
                    assured: null,
                    partner: null,
                    person: null,
                    persons: null,
                    isAssured: null,
                    isPartner: null,
                    saveResponse: success.data
                };

                $state.go('root.life.summary', toSave);
            }, function (error) {
                toSave.saveResponse = null;
                popUpService.showPopUpWithError(error.data, {
                    head: 'Wystąpił błąd',
                    content: 'Nie udało się zapisać deklaracji, prosimy spróbować ponownie później.'
                });

                $timeout(function () {
                    el.removeClass('disabled');
                }, 1500);
            });
        }

        if (missingOncologyConfirmation || missingCardiologyConfirmation) {
            var specialPackages = $scope.specialPackages.join(' oraz ');
            let content = 'Aby przystąpić do ubezpieczenia ' + specialPackages + ' należy zaznaczyć wymagane oświadczenie o stanie zdrowia. Brak zaakceptowania oświadczenia równoznaczny jest z brakiem możliwości przystąpienia do tego ubezpieczenia.';
            $scope.showPopup('', 'UWAGA', content, 'Zapisz mimo to', saveDeclaration, 'Popraw', enableNext);
            return 0;
        }

        saveDeclaration();
    };


    function assignPackageInfoToPersons(list, choose, lifePackages) {
        let types = {};
        angular.forEach(lifePackages, function (group) {
            angular.forEach(group.item, function (item) {
                types[item.id] = {
                    type: group.code,
                    name: group.name
                };
            });
        });
        angular.forEach(choose, function (chosen, personKey) {
            if (typeof list[personKey] === "undefined") {
                return;
            }
            list[personKey].agreements.hasOncologyPackage = false;
            list[personKey].agreements.oncologyPackage = false;
            list[personKey].agreements.hasCardiologyPackage = false;
            list[personKey].agreements.cardiologyPackage = false;
            angular.forEach(chosen, function (pkg) {
                if (types[pkg].type === 'ONCOLOGY') {
                    list[personKey].agreements.hasOncologyPackage = true;
                    $scope.specialPackages.push(types[pkg].name);
                }
                if (types[pkg].type === 'CARDIOLOGY') {
                    list[personKey].agreements.hasCardiologyPackage = true;
                    $scope.specialPackages.push(types[pkg].name);
                }
            });
        });
    }

    $scope.toggleAllRequired = function (person) {
        var isAllRequiredChecked = $scope.isAllRequiredChecked(person);
        angular.forEach(person.agreements.requiredAgreementsList, function (agreement) {
            if (!agreement.explicit) {
                agreement.accepted = !isAllRequiredChecked;
            }
        });
    }

    $scope.isAllRequiredChecked = function (person) {
        var requiredAccepted = true;
        angular.forEach(person.agreements.requiredAgreementsList, function (agreement) {
            requiredAccepted = requiredAccepted && agreement.accepted;
        });

        if (requiredAccepted && requiredAccepted !== person.agreements.acceptRequired) {
            person.agreements.isShowAllDeclarations = false;
            person.agreements.acceptRequired = requiredAccepted;
        } else if (!requiredAccepted && requiredAccepted !== person.agreements.acceptRequired) {
            person.agreements.isShowAllDeclarations = true;
            person.agreements.acceptRequired = requiredAccepted;
        }

        return requiredAccepted;
    }

    $scope.data = {};
    $scope.data.agreements = prepareAgreements();


    function prepareAgreements() {
        if (Configurator.lifeInsuranceWithPayments.insurer === 'Unum') {
            return prepareUnumAgreements();
        } else if (Configurator.lifeInsuranceWithPayments.insurer === 'Pzu') {
            return preparePzuAgreements();
        } else {
            return [];
        }
    }

    function prepareUnumAgreements() {
        return [
            {
                id: 0,
                content: '<span>1. Oświadczam, zgodnie z moją najlepszą wiedzą i przekonaniem, że wszystkie odpowiedzi i informacje zawarte we Wniosku przystąpienia do ubezpieczenia (zwanym dalej „Wnioskiem”) są prawdziwe i prawidłowo zapisane.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 1,
                content: '<span>2. Oświadczam, że otrzymałem/ otrzymałam przed podpisaniem niniejszego Wniosku treść warunków Umowy ubezpieczenia, w tym OWU oraz Warunki umów dodatkowych i wyrażam zgodę na objęcie mnie ochroną ubezpieczeniową na warunkach w nich określonych, jak również na ustaloną wysokość Sum ubezpieczenia.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 2,
                content: '<span>3. Podanie wymienionych powyżej danych jest obligatoryjne i następuje w związku z objęciem ochroną ubezpieczeniową. Szczegółowe informacje dotyczące przetwarzania przez Unum danych osobowych w związku z objęciem ochroną ubezpieczeniową zawarte są w dokumencie „Informacje dotyczące przetwarzania danych osobowych w związku z objęciem ochroną ubezpieczeniową”. Oświadczam, iż otrzymałem/ otrzymałam i zapoznałem/ zapoznałam się z tym dokumentem.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 3,
                content: '<span>4. Wyrażam zgodę na przekazywanie przez Unum danych osobowych dotyczących stanu mojego zdrowia zakładowi reasekuracji, w sytuacji gdy jest to wymagane w związku z reasekuracją ryzyk ubezpieczeniowych.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 4,
                content: '<span>5. Wyrażam zgodę na uzyskanie przez Unum – na wniosek lekarza upoważnionego przez Unum – od podmiotów wykonujących działalność leczniczą w rozumieniu przepisów o działalności leczniczej, które udzielały lub będą udzielały świadczeń zdrowotnych na moją rzecz informacji – w tym kopii dokumentacji medycznej – o okolicznościach związanych z oceną ryzyka ubezpieczeniowego i weryfikacją podanych danych o stanie mojego zdrowia, ustaleniem prawa do świadczenia z zawartej na moją rzecz umowy ubezpieczenia i wysokością tego świadczenia, a także informacji o przyczynie mojej śmierci, z wyłączeniem wyników badań genetycznych.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 5,
                content: '<span>6. Wyrażam zgodę na uzyskanie przez Unum (na jego wniosek) od Narodowego Funduszu Zdrowia danych (nazw i adresów) świadczeniodawców, którzy udzielali świadczeń opieki zdrowotnej w związku z wypadkiem lub zdarzeniem losowym, w związku z weryfikacją danych dotyczących stanu zdrowia dla celów ustalenia prawa do świadczenia z zawartej umowy ubezpieczenia i wysokości tego świadczenia.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 6,
                content: '<span>7. Oświadczam, że przed wyrażeniem zgody na objęcie mnie ochroną ubezpieczeniową, udostępniono mi Ogólne Warunki Ubezpieczenia „Assistance Medyczny” (dalej jako „OWU Assistance”) oraz Zasady Ochrony Ubezpieczających i Ubezpieczonych (tzw. Polityka Prywatności AWP) i wyrażam wolę objęcia mnie ochroną ubezpieczeniową w ramach Umowy ubezpieczenia „Assistance Medyczny”, w której ubezpieczycielem jest AWP P&C S.A. Oddział w Polsce (dalej jako „AWP”), z siedzibą w Warszawie</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 7,
                content: '<span>8. W związku z objęciem ochroną ubezpieczeniową w ramach Umowy ubezpieczenia „Assistance Medyczny” wyrażam zgodę na przekazywanie moich danych osobowych przez Unum do AWP. AWP jest odrębnym od Unum administratorem moich danych osobowych, a przetwarzane one będą w celach związanych z objęciem mnie ochroną ubezpieczeniową w ramach Umowy ubezpieczenia „Assistance Medyczny”.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 8,
                content: '<span>9. Oświadczam, że przekazałam/ przekazałem mojemu Partnerowi Życiowemu (o ile dotyczy) informacje dotyczące przetwarzania danych osobowych przez Unum zamieszczone w dokumencie „Informacje dotyczące przetwarzania danych osobowych w związku z objęciem ochroną ubezpieczeniową” oraz oświadczam, że w związku z wykonywaniem Umowy ubezpieczenia zawartej na rzecz Ubezpieczonego zostałam/ zostałem umocowana/ umocowany przez Partnera Życiowego do wyrażenia zgody w jego imieniu na przetwarzanie jego danych osobowych przez Unum w celu ich weryfikacji na etapie wypłaty Świadczenia.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 9,
                content: '<span>10. Oświadczam, że w dniu podpisania niniejszego Wniosku nie przebywam na zwolnieniu lekarskim, w szpitalu, w hospicjum ani w zakładzie opiekuńczo-leczniczym, na zasiłku rehabilitacyjnym i nie orzeczono w stosunku do mnie niezdolności do pracy.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 10,
                content: '<span>11. Posiadam wiedzę, że warunkiem objęcia mnie ww. umową ubezpieczenia oraz ochroną ubezpieczeniową w jej ramach jest zapłata przeze mnie należnej składki ubezpieczeniowej a jej nieuiszczenie w całości lub części w wyznaczonym terminie oznaczać będzie rezygnację z uczestnictwa w ww. umowie ubezpieczenia i będzie równoznaczne z rozwiązaniem przeze mnie ww. umowy ubezpieczenia z dniem upływu terminu do zapłaty składki, która nie została uiszczona w całości lub części.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 11,
                content: '<span>1. Udzielam Ubezpieczającemu pełnomocnictwa, z prawem do udzielenia dalszego pełnomocnictwa, do składania w moim imieniu oświadczeń woli w zakresie wyrażania zgody na dokonanie zmian Umowy ubezpieczenia w okresie jej trwania, w zakresie modyfikacji warunków Umowy ubezpieczenia, zmian w wysokości Sum ubezpieczenia oraz Składki.</span>',
                accepted: false,
                required: false,
                explicit: true
            },
            {
                id: 12,
                content: '<span>2. Wyrażam zgodę na przesyłanie przez Unum za pośrednictwem środków komunikacji elektronicznej (na wskazany adres e-mail) korespondencji dotyczącej umowy ubezpieczenia na życie, w tym informacji, które zgodnie z obowiązującymi przepisami prawa zakład ubezpieczeń zobowiązany jest przekazywać na piśmie.</span>',
                accepted: false,
                required: false,
                explicit: true
            },
            {
                id: 13,
                content: '<span>1. Oświadczam, zgodnie z moją najlepszą wiedzą i przekonaniem, że nie byłem/-am i nie jestem w trakcie diagnostyki oraz nie byłem/-am i nie jestem leczony/-a z powodu następujących schorzeń: wady serca, choroby niedokrwiennej serca, choroby wieńcowej, zawału serca, udaru mózgu, cukrzycy, przewlekłych chorób wątroby, trzustki, nerek, zaburzeń psychicznych i zaburzeń zachowania, choroby nowotworowej.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: true
            },
            {
                id: 14,
                content: '<span>2. Oświadczam, że w ciągu ostatnich 12 miesięcy (poprzedzających datę podpisania niniejszego oświadczenia) nie przebywałem/(-am) na zwolnieniu lekarskim (z powodu choroby lub nieszczęśliwego wypadku) dłuższym niż 21 dni oraz w ciągu ostatnich 5 lat nie otrzymywałem/(-am) renty z tytułu niezdolności do pracy lub zasiłku rehabilitacyjnego trwającego dłużej niż 6 miesięcy.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: true
            },
        ];
    }

    function preparePzuAgreements() {
        return [
            {
                id: 0,
                content: '<span>Oświadczam, że byłem objęty ochroną ubezpieczeniową w Programie ubezpieczeniowym dla członków Klubu PZU Pomoc w Życiu (Pracowników PKP Polskich Linii Kolejowych, PKP Intercity, Polskich Kolei Państwowych i Spółek Powiązanych oraz ich małżonków i pełnoletnich dzieci).</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 1,
                content: '<span>Chcę zostać objęta/y ochroną ubezpieczeniową z sumą ubezpieczenia i na warunkach określonych w umowie, które zostały mi doręczone przed przystąpieniem do ubezpieczenia.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            }, {
                id: 2,
                content: `<span>
                    W razie wystąpienia zdarzenia upoważniam kierownictwo wszystkich placówek służby zdrowia i lekarzy
                    do udzielania PZU Życie SA informacji o moim stanie zdrowia i stanie zdrowia moich małoletnich dzieci
                    <a href="" title="" class="hint-link inline small" data-show-hint="">
                        <i class="circle">1</i>
                        <div class="hint-box">
                            Dotyczy dodatkowych grupowych ubezpieczeń związanych z życiem i zdrowiem dziecka.
                        </div>
                    </a>
                    w tym obejmujących: przyczyny hospitalizacji i leczenia ambulatoryjnego, wyniki badań diagnostycznych
                    (z wyłączeniem badań genetycznych), przeprowadzonych konsultacji, wyniki leczenia i rokowań,
                    a także do przekazania kopii mojej dokumentacji medycznej i dokumentacji medycznej moich
                    małoletnich dzieci. Upoważnienie to jest potrzebne, aby ustalić odpowiedzialność zakładu ubezpieczeń
                    z tytułu zdarzeń objętych ubezpieczeniem i wysokość świadczenia lub przyczynę śmierci. 
                    W razie wystąpienia zdarzenia upoważniam Narodowy Fundusz Zdrowia do przekazania do PZU Życie SA
                    nazw i adresów świadczeniodawców, którzy udzielili mi lub moim małoletnim dzieciom świadczeń
                    opieki zdrowotnej. Upoważnienie to jest potrzebne, aby ustalić odpowiedzialność PZU Życie SA
                    oraz wysokość świadczenia. Powyższe upoważnienia obejmują przekazanie informacji lub dokumentacji
                    medycznej również po mojej śmierci lub po śmierci moich małoletnich dzieci.
                    </span><span class="required">*</span>`,
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 3,
                content: `<span>
                    Zgadzam się na udostępnienie moich danych osobowych i ich dalsze przetwarzanie przez świadczeniodawcę
                    PZU Zdrowie SA, oraz dalsze przekazanie tych danych własnym lub współpracującym placówkom medycznym
                    w celu podjęcia wszelkich działań związanych z organizacją i realizacją świadczeń wynikających
                    z wybranego przeze mnie zakresu świadczeń zdrowotnych
                    <a href="" title="" class="hint-link inline small" data-show-hint="">
                        <i class="circle">2</i>
                        <div class="hint-box">
                            Dotyczy dodatkowego grupowego ubezpieczenia następstw nieszczęśliwego wypadku na drodze lub
                            w pracy – usługi medyczne lub dodatkowego grupowego ubezpieczenia na wypadek ciężkiej
                            choroby - usługi medyczne lub dodatkowego grupowego ubezpieczenia zdrowotnego Opieka Medyczna
                        </div>
                    </a>.
                    </span><span class="required">*</span>`,
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 4,
                content: '<span>W dniu podpisania deklaracji przystąpienia nie przebywam na zwolnieniu lekarskim, w szpitalu, hospicjum, placówce dla przewlekle chorych, na świadczeniu rehabilitacyjnym oraz nie uznano w stosunku do mnie niezdolności do pracy lub niezdolności do służby orzeczeniem właściwego organu (nie stosuje się w grupowym ubezpieczeniu PZU W RAZIE WYPADKU).</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 5,
                content: '<span>Wyrażam zgodę na przetwarzanie przez PZU Życie SA moich danych osobowych dotyczących stanu zdrowia zawartych w deklaracji przystąpienia do ubezpieczenia – w celu przystąpienia oraz wykonywania umowy ubezpieczenia, a także przekazanych PZU Życie SA przez placówki służby zdrowia, lekarzy lub przeze mnie w trakcie obowiązywania umowy ubezpieczenia – w celu wykonania umowy ubezpieczenia. Zgoda jest dobrowolna, ale konieczna w celu realizacji umowy.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 6,
                content: '<span>Oświadczam, że zapoznałam/em się z informacją o przetwarzaniu moich danych osobowych, zawartą w dostarczonym mi dokumencie Informacja Administratora danych osobowych.</span><span class="required">*</span>',
                accepted: false,
                required: true,
                explicit: false
            },
            {
                id: 7,
                content: '<span>' +
                    '<p>Dodatkowe oświadczenie dotyczące zdrowia, składane wyłącznie przez MAŁŻONKA, PARTNERA ŻYCIOWEGO ' +
                    'i PEŁNOLETNIE DZIECKO, przystępujących do grupowego ubezpieczenia typ P Plus o kodzie PTGP34 ' +
                    'oraz ubezpieczeń dodatkowych, którzy bezpośrednio przed przystąpieniem do ubezpieczenia albo nie ' +
                    'byli objęci innym ubezpieczeniem grupowym na życie w PZU Życie SA, albo byli objęci takim ' +
                    'ubezpieczeniem krócej niż 12 miesięcy.</p>' +
                    '<p>Oświadczam, że:</p>' +
                    '<p>1. Nigdy nie zdiagnozowano u mnie żadnej z niżej wymienionych chorób, ani też nie jestem w trakcie diagnostyki objawów chorobowych żadnej z nich:</p>' +
                    '<p class="margin_left_20">1) miażdżyca, tętniak aorty, zatorowość płucna, zakrzepica żylna, choroba niedokrwienna serca (choroba wieńcowa), zawał serca, zastawkowa wada serca, migotanie przedsionków;</p>' +
                    '<p class="margin_left_20">2) przemijające zaburzenia krążenia mózgowego, krwotok środczaszkowy, udar mózgu, choroba Alzheimera, stwardnienie rozsiane, padaczka;</p>' +
                    '<p class="margin_left_20">3) przewlekła obturacyjna choroba płuc;</p>' +
                    '<p class="margin_left_20">4) przewlekła niewydolność nerek;</p>' +
                    '<p class="margin_left_20">5) alkoholowa choroba wątroby, toksyczne uszkodzenie wątroby, niewydolność wątroby, przewlekłe zapalenie wątroby, marskość wątroby, przewlekle zapalenie trzustki;</p>' +
                    '<p class="margin_left_20">6) cukrzyca (z wyłączeniem cukrzycy ciężarnych), reumatoidalne zapalenie stawów, zakażenie wirusem HIV.</p>' +
                    '<p>2. W ciągu ostatnich 10 lat nie zdiagnozowano u mnie żadnego nowotworu złośliwego, ani też nie jestem w trakcie diagnostyki objawów chorobowych nowotworu złośliwego.</p>' +
                    '<p>3. W ciągu ostatnich 10 lat nie przebyłem jako biorca przeszczepu wątroby, serca, nerki, płuca, szpiku, ani też nie oczekuję na taki przeszczep.</p>' +
                    '<p>UWAGA! Jeżeli w Twoim przypadku powyższe oświadczenie w którymkolwiek punkcie nie jest prawdziwe a mimo to przystąpisz do ubezpieczenia, PZU Życie SA, zgodnie z art. 815 Kodeksu cywilnego, może odmówić Ci świadczenia.<span class="required">*</span></p>' +
                    '</span>',
                accepted: true,
                required: true,
                explicit: false
            },
            {
                id: 8,
                content: '<span>Zgadzam się na założenie przez PZU Życie SA dedykowanego konta elektronicznego (trwały nośnik), na które mogę otrzymywać dokumenty ubezpieczenia, powiadomienia, wnioski i oświadczenia oraz poprzez które mogę zawierać lub przystępować do innych umów ubezpieczenia. Zapoznałam/em się z Regulaminem świadczenia usług drogą elektroniczną i akceptuję jego treść. Zgadzam się na otrzymywanie powiadomień o zmianach zawartości konta za pośrednictwem środków komunikacji elektronicznej (w tym wiadomości sms lub e-mail).</span>',
                accepted: false,
                required: false,
                explicit: false
            },
            {
                id: 9,
                content: '<span>Wyrażam zgodę na udostępnienie przez PZU Życie SA moich danych osobowych podmiotom z grupy PZU, tj. PZU SA, PTE PZU SA, TFI PZU SA, PZU Pomoc SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA, w ich własnych celach marketingowych, obejmujących profilowanie zmierzające do określenia preferencji lub potrzeb w zakresie produktów ubezpieczeniowych i innych produktów finansowych oraz przedstawienia odpowiedniej oferty.</span>',
                accepted: false,
                required: false,
                explicit: false
            },
            {
                id: 10,
                content: '<span>Wyrażam zgodę na otrzymywanie od PZU SA, PZU Życie SA, PTE PZU SA, TFI PZU SA, PZU Pomoc SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA informacji marketingowych za pośrednictwem środków komunikacji elektronicznej (e-mail, SMS/MMS).</span>',
                accepted: false,
                required: false,
                explicit: false
            },
            {
                id: 11,
                content: '<span>Wyrażam zgodę na otrzymywanie od PZU SA, PZU Życie SA, PTE PZU SA, TFI PZUSA, PZU Pomoc SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA informacji marketingowych za pośrednictwem połączeń głosowych (rozmowa telefoniczna, komunikaty głosowe IVR)</span>',
                accepted: false,
                required: false,
                explicit: false
            },
            {
                id: 12,
                content: '<span>Wyrażam zgodę na przetwarzanie moich danych osobowych przez PZU Życie SA w celu przekazywania mi treści marketingowych dotyczących produktów ubezpieczeniowych i innych produktów finansowych, kiedy nie będę posiadać ubezpieczenia w tej firmie.</span>',
                accepted: false,
                required: false,
                explicit: false
            },
            {
                id: 13,
                content: '<span>Wyrażam zgodę na przesyłanie informacji, które mają związek z moim ubezpieczeniem w PZU Życie SA za pośrednictwem środków komunikacji elektronicznej, w tym wiadomości SMS/MMS lub e-mail, na wskazany przeze mnie numer telefonu lub adres mailowy. W razie zmiany podanych przeze mnie danych kontaktowych, zobowiązuję się uaktualniać moje dane, dzięki którym będę otrzymywać informacje za pośrednictwem środków komunikacji elektronicznej.</span>',
                accepted: false,
                required: false,
                explicit: false
            },
        ];
    }

    $scope.data.requiredAgreements = $scope.data.agreements.filter(function (single) {
        return single.required && !single.accepted && !single.explicit;
    });
    $scope.data.requiredAgreementsNoCheckbox = $scope.data.agreements.filter(function (single) {
        return single.required && single.accepted && !single.explicit;
    });
    $scope.data.requiredExplicitAgreements = $scope.data.agreements.filter(function (single) {
        return single.required && single.explicit;
    });
    $scope.data.optionalAgreements = $scope.data.agreements.filter(function (single) {
        return !single.required;
    });


    $scope.data.declineInstruction = prepareDeclineInstruction();

    function prepareDeclineInstruction() {
        if (Configurator.lifeInsuranceWithPayments.insurer === 'Pzu') {
            return `W zakresie, w jakim podstawą przetwarzania Pani/Pana danych osobowych jest zgoda, ma Pani/Pan prawo
                jej wycofania. Zgodę można odwołać w każdym czasie w oddziale lub wysyłając e-mail na adres
                kontakt@pzu.pl albo pismo na adres PZU, ul. Postępu 18a, 02-676 Warszawa. Wycofanie zgody nie wpływa
                na zgodność z prawem przetwarzania dokonanego na podstawie zgody przed jej wycofaniem.`;
        } else {
            return null;
        }
    }

    $scope.data.documents = prepareDocuments();

    function prepareDocuments() {
        if (Configurator.lifeInsuranceWithPayments.insurer === 'Unum') {
            return {
                informationClause: {
                    link: 'Files/life/unum/obowiazek_informacyjny_unum.pdf',
                    name: 'Klauzula informacyjna UNUM'
                },
                insuranceConditions: [
                    {
                        link: 'Files/life/unum/karta_produktu_unum.pdf',
                        name: 'Karta produktu'
                    }
                ]
            };
        } else if (Configurator.lifeInsuranceWithPayments.insurer === 'Pzu') {
            return {
                informationClause: {
                    link: 'Files/life/pzu_zycie_klauzula_informacyjna.pdf',
                    name: 'Klauzula informacyjna PZU Życie'
                },
                insuranceConditions: [
                    {
                        link: 'Files/life/pzu/kontynuacja/OWU.pdf',
                        name: 'Dokument zawierający informacje o produkcie ubezpieczeniowym i Ogólne Warunki Grupowego Ubezpieczenia typ P PLUS'
                    },
                    {
                        link: 'Files/life/pelnomocnictwo_pzu.pdf',
                        name: 'Upoważnienie PZU Życie SA'
                    },
                    {
                        link: 'Files/life/pzu/kontynuacja/regulamin_eru.pdf',
                        name: 'Regulamin świadczenia usług drogą elektroniczną za pośrednictwem aplikacji rejestrator ubezpieczeń grupowych'
                    }
                ]
            };
        } else {
            return {
                informationClause: {},
                insuranceConditions: {}
            };
        }
    }

    (function prepareAgreementsForPersons(personsList, choose, requiredAgreements, requiredExplicitAgreements, optionalAgreements) {
        var requiredAgreementsList = requiredAgreements.map(function (single) {
            return {accepted: false, id: single.id};
        });
        var requiredExplicitAgreementsList = requiredExplicitAgreements.map(function (single) {
            return {accepted: false, id: single.id};
        });
        var optionalAgreementsList = optionalAgreements.map(function (single) {
            return {accepted: false, id: single.id};
        });
        angular.forEach(choose, function (singleChoose, chooseKey) {
            var single = personsList[chooseKey];
            if (typeof single === "undefined") {
                return;
            }
            if (single.agreements) {
                return;
            }
            single.agreements = {
                isShowAllDeclarations: true,
                acceptRequired: false,
                requiredAgreementsList: angular.copy(requiredAgreementsList),
                requiredExplicitAgreementsList: angular.copy(requiredExplicitAgreementsList),
                optionalAgreementsList: angular.copy(optionalAgreementsList),
                sameAsFirst: single.type !== 'USER'
            };
            console.log(single.agreements);
        });
    })($scope.persons, $scope.choose, $scope.data.requiredAgreements, $scope.data.requiredExplicitAgreements, $scope.data.optionalAgreements);

    function PopUpInfoCtrl($scope, $mdDialog, locals, config) {
        $scope.locals = locals;
        $scope.config = config;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $scope.config.cancelCallback();
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $scope.locals.button.confirmCallback();
            $mdDialog.hide($scope.locals);
        };
    }

    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals', 'config'];
    $scope.showPopup = function (ev, head, content, confirm, confirmCallback, cancelText, cancelCallback) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Configurator.CORE.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                head: head,
                content: content,
                button: {
                    text: confirm,
                    target: null,
                    confirmCallback: confirmCallback
                }
            },
            config: {
                cancelButton: cancelText,
                cancelCallback: cancelCallback
            }
        }).then(function (data) {

        }, function () {

        });
    };

    $scope.$watch('person', function (oldVal, newVal) {
        // console.log(oldVal, newVal);
        if (oldVal !== newVal) {
            for (var a = 0; a < $scope.assured.length; a++) {
                if ($scope.assured[a].sameAddress) {
                    $scope.assured[a].city = $scope.person.address.city;
                    $scope.assured[a].street = $scope.person.address.street;
                    $scope.assured[a].number = $scope.person.address.number;
                    $scope.assured[a].apartment = $scope.person.address.apartment;
                    $scope.assured[a].zipCode = $scope.person.address.zipCode;
                }
            }
        }
    }, true);
}]);
